export const updatePaymentMethodsArray = (schema, objectId, newArray) => {
  const newData = [...schema];
  const objectIndex = newData.findIndex((obj) => obj.id === objectId);

  if (objectIndex !== -1) {
    newData[objectIndex].items = newArray;
  }
};


export const updateAllCurrencySchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };

export const updateAllCountrySchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };

export const updateAllPspSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);
    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
